import { Injectable } from '@angular/core';

@Injectable()
export class DemoProvider {

  demoMode: boolean;

  constructor() {
  }


}



// WEBPACK FOOTER //
// ./src/providers/demo/demo.ts